import { useMemo } from 'react'
import { SendIcon } from 'lucide-react'
import { Link } from 'react-router'

import { data } from './data'
import { NavGroup } from './nav-group'

import logoUrl from '@/assets/Logo.svg'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar'
import { paths } from '@/config/path'
import { TrialSidebarItem } from '@/features/stripe-payments/components/trial-sidebar-item'
import { useSentryFeedback } from '@/hooks/use-sentry-feedback'
import { useAuthenticatedUser } from '@/state/session'

export function AppSidebar() {
  const { profile: user } = useAuthenticatedUser()
  const items = useMemo(() => data[user.profile], [user.profile])

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <AppTitle />
      </SidebarHeader>
      <SidebarContent>
        {items.map((props) => (
          <NavGroup key={props.title} {...props} />
        ))}
      </SidebarContent>
      <SidebarCustomFooter />
    </Sidebar>
  )
}

const SidebarCustomFooter = () => {
  const { openFeedback } = useSentryFeedback()

  return (
    <SidebarFooter>
      <TrialSidebarItem />
      <SidebarMenu>
        <SidebarMenuItem onClick={() => openFeedback()}>
          <SidebarMenuButton>
            <SendIcon />
            <span>Faire un retour</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarFooter>
  )
}

export function AppTitle() {
  const { setOpenMobile } = useSidebar()
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg" className="gap-0 py-0 hover:bg-transparent active:bg-transparent" asChild>
          <div>
            <Link
              to={paths.app.root.path}
              onClick={() => setOpenMobile(false)}
              className="flex flex-row flex-1 items-center text-start text-sm leading-tight"
            >
              <img src={logoUrl} alt="Lablink Dental logo" className="size-7 rounded-lg border" />
              <span className="truncate font-bold ml-2">Lablink Dental</span>
            </Link>
          </div>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
